import {EResellerIds} from 'src/containers/User';
import {
  MaxBotCircleIcon,
  MaxCircleIcon,
  WhatsAppCircleIcon,
  WhatsappBusinessCircleIcon,
} from 'src/icons';

export enum EActionNews {
  FILL_DETAILS_REMINDER = 'FILL_DETAILS_REMINDER',
  ACCEPT_TARIFFS_REMINDER = 'ACCEPT_TARIFFS_REMINDER',
  ACCEPT_MM_API_REMINDER = 'ACCEPT_MM_API_REMINDER',
  MAX_BOT_CONNECTION_PROMO = 'MAX_BOT_CONNECTION_PROMO',
  DIALOGS_PROMO = 'DIALOGS_PROMO',
}

export type TChannelChip = {
  icon: TSvgComponentType;
  label: string;
  color: TThemeColor;
};

const MAX_BOT_CHIP: TChannelChip = {icon: MaxBotCircleIcon, label: 'MAX Bot', color: 'blue500'};
const MAX_CHIP: TChannelChip = {icon: MaxCircleIcon, label: 'MAX', color: 'pink300'};
const WHATSAPP_CHIP: TChannelChip = {
  icon: WhatsAppCircleIcon,
  label: 'WhatsApp',
  color: 'green400',
};
const WHATSAPP_BUSINESS_APP_CHIP: TChannelChip = {
  icon: WhatsappBusinessCircleIcon,
  label: 'WhatsApp Business App',
  color: 'green400',
};

export const DIALOGS_PROMO_CHIPS_BY_RESELLER: Partial<Record<EResellerIds, TChannelChip[]>> = {
  [EResellerIds.OSK_ID]: [MAX_BOT_CHIP, MAX_CHIP, WHATSAPP_CHIP, WHATSAPP_BUSINESS_APP_CHIP],
  [EResellerIds.MFM_ID]: [WHATSAPP_CHIP, WHATSAPP_BUSINESS_APP_CHIP],
  [EResellerIds.KZ_ID]: [WHATSAPP_CHIP, WHATSAPP_BUSINESS_APP_CHIP],
};
